import { formatISODate } from '../../util/datetime-fns';
import type { AutocompleteOption } from '../types';

export const FhhHiddenFields = ({
    destinationData,
    numOfBedrooms,
    numOfBeds,
    startDate,
    endDate,
}: {
    destinationData?: AutocompleteOption | null;
    numOfBedrooms?: number;
    numOfBeds?: number;
    startDate?: Date | null;
    endDate?: Date | null;
}) => {
    if (!destinationData && !numOfBedrooms && !numOfBeds && !startDate && !endDate) return null;

    return (
        <>
            {destinationData &&
                (destinationData.bounds ? (
                    <>
                        <input type="hidden" name="lat_ne" value={destinationData.bounds.northeast_lat} />
                        <input type="hidden" name="lat_sw" value={destinationData.bounds.southwest_lat} />
                        <input type="hidden" name="lng_ne" value={destinationData.bounds.northeast_lng} />
                        <input type="hidden" name="lng_sw" value={destinationData.bounds.southwest_lng} />
                        <input type="hidden" name="country" value={destinationData.country} />
                        <input type="hidden" name="city" value={destinationData.city || ''} />
                    </>
                ) : (
                    <input type="hidden" name="destination" value={destinationData.text} />
                ))}

            <input type="hidden" name="no_of_bedrooms_from" value={numOfBedrooms ?? 1} />
            <input type="hidden" name="no_of_beds_from" value={numOfBeds ?? 1} />

            {startDate && <input type="hidden" name="booking_from" value={formatISODate(startDate)} />}
            {endDate && <input type="hidden" name="booking_to" value={formatISODate(endDate)} />}
        </>
    );
};
